
import { defineComponent, onMounted } from "vue";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import { CookieComponent } from "./assets/ts/components";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();
    onMounted(() => {
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
    });
  },
});
